export const PRESENTATION_WIDTH = 1558;
export const PRESENTATION_HEIGHT = 720;

export const BLOCK_TYPE = "block_type"
export const SLIDER_META_KEY = 'idecide/slider';
export const RUB_SCREEN_META_KEY = 'idecide/rub-your-screen';
export const MENU_BUTTON_META_KEY = 'idecide/menu-button';
export const INPUT_FIELD_META_KEY = 'idecide/input-field';
export const CALCULATOR_META_KEY = 'idecide/calculator';
export const BLOCK_ACTION_META_KEY = 'idecide/block-action-id';
export const BLOCK_UUID_META_KEY = 'idecide/playback/uuid';
export const BLOCK_TRIM_OFFSET_META_KEY = 'idecide/playback/trimOffset';
export const BLOCK_TRIM_LENGTH_META_KEY = 'idecide/playback/trimLength';
export const BLOCK_VIDEO_POSTER_URI_META_KEY = 'idecide/playback/posterUri';
export const BLOCK_VIDEO_LOWRES_URI_META_KEY = 'idecide/playback/lowResUri';

export const IDECIDE_TEMPLATES_SOURCE_ID = 'idecide/templates';
export const IDECIDE_TEMPLATES_INTRO_SOURCE_ID = 'idecide/templates/intro';
export const IDECIDE_TEMPLATES_OTHER_SOURCE_ID = 'idecide/templates/other';
export const IDECIDE_TEMPLATES_ENTRY = 'idecide/templates/entry';
export const IDECIDE_TEMPLATES_INTRO_ENTRY = 'idecide/templates/intro';
export const IDECIDE_TEMPLATES_OTHER_ENTRY = 'idecide/templates/other';
export const FORMS_ENTRY_ID = 'idecide.forms';

//Short code tokens that will be replaced with real data
export const replaceTokensInString = [
    ["Sender's Name", "[sender-name]"],
    ["Sender's First Name", "[sender-name-first]"],
    ["Sender's Last Name", "[sender-name-last]"],
    ["Sender's Email Address", "[sender-email]"],
    ["Viewer's Name", "[viewer-name]"],
    ["Viewer's First Name", "[viewer-name-first]"],
    ["Viewer's Last Name", "[viewer-name-last]"],
    ["Viewer's Email Address", "[viewer-email]"],
    ["Viewer's Country", "[viewer-country]"],
    ["Viewer's State/Province", "[viewer-region]"],
    ["Current Date", "[current-date]"],
    ["Current Time", "[current-time]"],
    ["Viewer's City", "[viewer-city]"]
];

export const RUB_YOUR_SCREEN_ADOBE_COMPOSITION_ID = '801BDCAF735D47FBA40C5D8A02EE481B';
export const RUB_YOUR_SCREEN_SLIDE_JS_URL = '/player/rub/Published/slide.js';
export const DYNAMIC_VARIABLES_UPDATED_EVENT = 'dynamic-variables-updated';

// New canvas-based implementation URLs
export const RUB_YOUR_SCREEN_COVER_JS_URL = '/player/rub/cover/coverFunctions.js';
export const RUB_YOUR_SCREEN_COVER_CSS_URL = '/player/rub/cover/coverStyles.css';
export const RUB_YOUR_SCREEN_COVER_IMAGE_URL = '/player/rub/cover/coverImage.jpg';
export const RUB_YOUR_SCREEN_ICON_URL = '/player/rub/cover/converIcon.svg';
export const RUB_YOUR_SCREEN_AUDIO_URL = '/player/rub/cover/scratch.mp3';
